import React, { type FC } from 'react';

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex h-16 w-full items-center justify-between bg-secondary px-6 text-sm text-white sm:px-10">
      <div>
        ©{currentYear},{' '}
        <a target="blank" href="https://themindessence.com">
          MindEssence
        </a>
      </div>
      <a
        target="blank"
        href="https://instagram.com/andersonmirandacoach"
        className="shrink-0"
      >
        <img src="./instagram_logo.svg" className="size-6" />
      </a>
    </div>
  );
};

export default Footer;
